import React, { Component } from 'react';
import {
  string, bool, func, object,
} from 'prop-types';

import { HiddenCheckboxV2, CheckboxContainerV2 } from './CheckboxV2Styles';
import MLIcon from '../MLIcon/MLIcon';
import theme from '../../../styles-and-themes/themes/theme';

class CheckboxV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
    };
  }

  focusIn = () => {
    this.setState({ focused: true });
  }

  focusOut = () => {
    this.setState({ focused: false });
  }

  render() {
    const {
      id, className, checked, onClick, onChange, style, ...props
    } = this.props;
    return (
      <CheckboxContainerV2
        style={style}
        className={`styledButton ${className}`}
        onClick={onClick}
        focused={this.state.focused}
      >
        <HiddenCheckboxV2
          type="checkbox"
          className="hiddenCheckbox"
          id={id}
          checked={checked}
          onFocus={this.focusIn}
          onBlur={this.focusOut}
          {...props}
        />
        <MLIcon
          type={checked ? 'checkbox_rounded' : 'checkbox_rounded_unchecked'}
          fill={checked ? 'rgb(3, 0, 165)' : theme.white}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          aria-hidden
        />
      </CheckboxContainerV2>
    );
  }
}

CheckboxV2.defaultProps = {
  className: 'cdlCheckbox',
  disabled: false,
  checked: false,
  style: {},
};

CheckboxV2.propTypes = {
  id: string.isRequired,
  className: string,
  title: string.isRequired,
  disabled: bool,
  checked: bool,
  onClick: func.isRequired,
  onChange: func.isRequired,
  style: object,
};

export default CheckboxV2;
